import type { FileUploadItem } from '@gov-nx/core/hooks';

export const getAttachmentsIds = (attachments?: FileUploadItem[]) =>
	attachments?.map((attachment) => attachment.fileId);
